import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr'
import FORM_INPUT_CLASS from './formInputClass'
import CalendarIcon from '../../ui/icons/CalendarIcon'
import ChevronDownIcon from '../../ui/icons/ChevronDownIcon'
import ClockIcon from '../../ui/icons/ClockIcon'

const DATETIME_VALUE = 'datetime_value'
const DATETIME_FORMAT = 'datetime_format'
const TIME_24HR = 'time_24hr'
const DATE_AND_TIME = 'date_and_time'
const ONLY_DATE = 'only_date'
const ONLY_TIME = 'only_time'

const CONFIG_BY_FORMAT = {
  [DATE_AND_TIME]: { enableTime: true, dateFormat: 'd/m/Y H:i', [TIME_24HR]: true },
  [ONLY_DATE]: { dateFormat: 'd/m/Y' },
  [ONLY_TIME]: { enableTime: true, noCalendar: true, dateFormat: 'H:i', [TIME_24HR]: true }
}

const SUBMIT_FORMAT_BY_FORMAT = {
  [DATE_AND_TIME]: 'Y-m-d H:i',
  [ONLY_DATE]: 'Y-m-d',
  [ONLY_TIME]: 'H:i'
}

// The payload delivers ISO8601, but an edited value comes back in the submit format: parsing an
// ISO string as 'H:i' would read 20:26 out of the year.
const ISO_VALUE = /^\d{4}-\d{2}-\d{2}T/u

const parseValue = (value, format) => {
  if (!value)
    return null
  return ISO_VALUE.test(value) ? new Date(value) : flatpickr.parseDate(value, SUBMIT_FORMAT_BY_FORMAT[format])
}

const ICON_CLASS = 'tw:pointer-events-none tw:absolute tw:top-1/2 tw:-translate-y-1/2 tw:flex'
const PREFIX_CLASS = `${ICON_CLASS} tw:left-3 tw:text-xl tw:text-gray-500`
const SUFFIX_CLASS = `${ICON_CLASS} tw:right-3 tw:text-base tw:text-gray-950`

const DateTimeMarkField = ({ mark, readonly, onChange }) => {
  const inputRef = useRef(null)
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  const format = mark.question.datetime_format || DATE_AND_TIME

  useEffect(() => {
    const instance = flatpickr(inputRef.current, {
      ...CONFIG_BY_FORMAT[format],
      locale: French,
      defaultDate: parseValue(mark.datetime_value, format),
      onChange: ([date]) => onChangeRef.current({
        [DATETIME_VALUE]: date ? flatpickr.formatDate(date, SUBMIT_FORMAT_BY_FORMAT[format]) : null
      })
    })
    return () => instance.destroy()
  }, [format])

  return (
    <div className="tw:relative tw:lg:w-1/2">
      <span className={PREFIX_CLASS}>
        {format === ONLY_TIME ? <ClockIcon /> : <CalendarIcon />}
      </span>
      <input
        ref={inputRef}
        className={`${FORM_INPUT_CLASS} tw:pl-10! tw:pr-10!`}
        disabled={readonly}
        placeholder="Sélectionner..."
        type="text"
      />
      <span className={SUFFIX_CLASS}>
        <ChevronDownIcon />
      </span>
    </div>
  )
}

DateTimeMarkField.propTypes = {
  mark: PropTypes.shape({
    [DATETIME_VALUE]: PropTypes.string,
    question: PropTypes.shape({
      [DATETIME_FORMAT]: PropTypes.string
    })
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool
}

DateTimeMarkField.defaultProps = {
  readonly: false
}

export default DateTimeMarkField
